import theme_default from "./theme_default_default.json";

const themes = {
  theme_default,
};

export function getConfigObjectData(type: string, slug: string) {
  return themes[`${type}_${slug}`];
}
